import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';
import Select from 'react-select'

class StateSchemes extends React.Component {
    

    dbts = [
        {'label' : 'No', 'value' : '0'},
        {'label' : 'Yes', 'value' : '1'}
    ]



    divyang_category = [
        {'label' : 'Yes', 'value' : '0'},
        {'label' : 'No', 'value' : '1'}
    ]

    beneficiary = [
        {'label' : 'APL', 'value' : '0'},
        {'label' : 'BPL', 'value' : '1'},
        {'label' : 'AAY', 'value' : '2'},
        {'label' : 'PHH', 'value' : '3'},
        {'label' : 'Applied / In Progress', 'value' : '4'},
        {'label' : 'Not Applicable', 'value' : '5'}
    ]

    caste = [
        {'label' : 'General', 'value' : '0'},
        {'label' : 'OBC', 'value' : '1'},
        {'label' : 'SC', 'value' : '2'},
        {'label' : 'ST', 'value' : '3'},
        {'label' : 'Particularly Vulnerable Tribal Group (PVTG)', 'value' : '4'}
    ]

    genders = [
        {'label' : 'Male', 'value' : '0'},
        {'label' : 'Female', 'value' : '1'},
        {'label' : 'Transgender', 'value' : '2'}
    ]
  

    marital_status = [
        {'label' : 'Married', 'value' : '0'},
        {'label' : 'Unmarried', 'value' : '1'},
        {'label' : 'Widowed / Widhower', 'value' : '2'},
        {'label' : 'Divorced', 'value' : '3'},
        {'label' : 'Seperated', 'value' : '4'}
    ]

    religions = [
        {'label' : 'Hindu', 'value' : '0'},
        {'label' : 'Muslim', 'value' : '1'},
        {'label' : 'Christian', 'value' : '2'},
        {'label' : 'Sikh', 'value' : '3'},
        {'label' : 'Parsion', 'value' : '4'},
        {'label' : 'Buddhism', 'value' : '5'}
    ]

    employment_status = [
        {'label' : 'Employed', 'value' : '0'},
        {'label' : 'Self Employed / Entrepreneur', 'value' : '1'},
        {'label' : 'Unemployed', 'value' : '2'}
    ]

    area = [
        {'label' : 'Urban', 'value' : '0'},
        {'label' : 'Rural', 'value' : '1'}
    ]

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getSchemes();
        this.getOccupations();
        this.getCategories();
    };


    
    getCategories = async()=>{
        var scheme_type = 1;
        this.setState({'scheme_type' : scheme_type});
        var response = await Api.GetRequest({}, 'schemes-and-services');
        if(response.status == 200){
            var categories = []
            await response.categories.map(async (category)=>{
                await categories.push({'value' : category.id, 'label' : category.title});
            })

            this.setState({'categories' : categories});
        }
        else{
            toast.error("Something went wrong. Please try again later.");
        }
       
    }

    getOccupations = async()=>{
        var response = await Api.GetRequest({}, 'occupations');
        if(response.status == 200){
            this.setState({'occupations' : response.occupations});
        }
    }


    getSchemes = async()=>{
        let state = this.props.params.state;
        let name = this.props.params.name;
        if(state){
            await this.setState({'state' : state, 'state_name' : name});
            var response = await Api.GetRequest({}, 'schemes/state/'+state);
            if(response.status == 200){
                this.setState({'schemes' : response.schemes});
            }
            else{

            }
        }
        else{
            this.props.navigate(-1)
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'schemes' : [],
            'occupations' : [],
            'age' : "",
            'state' : "",
            'state_name' : "",
            'family_income' : "",
            'category' : {'label' : '', 'value' : ''},
            'dbt' : {'label' : '', 'value' : ''},
            'beneficiary' : {'label' : '', 'value' : ''},
            'divyang_category' : {'label' : '', 'value' : ''},
            'marital_status' : {'label' : '', 'value' : ''},
            'caste' : {'label' : '', 'value' : ''},
            'gender' : {'label' : '', 'value' : ''},
            'religion' : {'label' : '', 'value' : ''},
            'employment' : {'label' : '', 'value' : ''},
            'area' : {'label' : '', 'value' : ''},
            'occupation' : {'label' : '', 'value' : ''},
            'searched_text' : ""
        };
    }

    
    resetFilters = async()=>{
        this.setState({
            'age' : "",
            'category' : {'label' : '', 'value' : ''},
            'dbt' : {'label' : '', 'value' : ''},
            'family_income' : "",
            'beneficiary' : {'label' : '', 'value' : ''},
            'divyang_category' : {'label' : '', 'value' : ''},
            'marital_status' : {'label' : '', 'value' : ''},
            'cast' : {'label' : '', 'value' : ''},
            'gender' : {'label' : '', 'value' : ''},
            'religion' : {'label' : '', 'value' : ''},
            'employment' : {'label' : '', 'value' : ''},
            'area' : {'label' : '', 'value' : ''},
            'occupation' : {'label' : '', 'value' : ''},
            'searched_text' : ""
        })
    }


    filterSchemes = async()=>{
        var data = {
            'scheme_type' : 1,
            'age' : this.state.age,
            'state' : this.state.state,
            'dbt' : this.state.dbt.value,
            'category' : this.state.category.value,
            'family_income' : this.state.family_income,
            'beneficiary' : this.state.beneficiary.value,
            'divyang_category' : this.state.divyang_category.value,
            'marital_status' : this.state.marital_status.value,
            'caste' : this.state.caste.value,
            'gender' : this.state.gender.value,
            'religion' : this.state.religion.value,
            'employment' : this.state.employment.value,
            'area' : this.state.area.value,
            'occupation' : this.state.occupation.value,
            'searched_text' : this.state.searched_text
        }
        var response = await Api.PostRequest(data, 'schemes');
        if(response.status == 200){
            this.setState({'schemes' : response.schemes});
        }
        else{

        }
    }


    searchSchemes = async(searched_text)=>{
        await this.setState({'searched_text' : searched_text});
        await this.filterSchemes();
    }


    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>{this.state.state_name} <br></br>State Govt. Schemes </h2>
                            </div> 
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main">
                    <div class="mx-2">
                        <div class="row" id="counter">
                            <div class="col-lg-3">
                                <div class="sidebar_first">
                                    <div class="sidebar_boxed">
                                        <div class="sidebar_heading_main justify-content-between d-flex align-items-center">
                                            <h4>Filter By</h4>
                                            <h5 onClick={()=>{this.resetFilters()}} style={{'color' : 'green'}}>Reset Filters</h5>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Gender</label>
                                            <Select isRtl={false} options={this.genders} value={this.state.gender} onChange={async(e)=>{await this.setState({"gender" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Age</label>
                                            <input type="number" style={{'height' : 'auto', background : '#FFFFFF'}} min={0} value={this.state.age} className="form-control border" onChange={async(e)=>{await this.setState({age : e.target.value}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Martial Status</label>
                                            <Select isRtl={false} options={this.marital_status} value={this.state.marital_status} onChange={async(e)=>{await this.setState({"marital_status" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Religion</label>
                                            <Select isRtl={false} options={this.religions} value={this.state.religion} onChange={async(e)=>{await this.setState({"religion" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Caste</label>
                                            <Select isRtl={false} options={this.caste}  value={this.state.caste} onChange={async(e)=>{await this.setState({"caste" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Divyang Category</label>
                                            <Select isRtl={false} options={this.divyang_category} value={this.state.divyang_category} onChange={async(e)=>{await this.setState({"divyang_category" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Ration Card Holder</label>
                                            <Select isRtl={false} options={this.beneficiary} value={this.state.beneficiary} onChange={async(e)=>{await this.setState({"beneficiary" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Employment Status</label>
                                            <Select isRtl={false} options={this.employment_status} value={this.state.employment} onChange={async(e)=>{await this.setState({"employment" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Occupation</label>
                                            <Select isRtl={false} options={this.state.occupations} value={this.state.occupation} onChange={async(e)=>{await this.setState({"occupation" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Monthly Income</label>
                                            <input type="number" style={{'height' : 'auto', background : '#FFFFFF'}} min={0} value={this.state.family_income} className="form-control border" onChange={async(e)=>{await this.setState({family_income : e.target.value}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Area</label>
                                            <Select isRtl={false} options={this.area} value={this.state.area} onChange={async(e)=>{await this.setState({"area" : e}); this.filterSchemes()}}/>
                                        </div>

                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Category</label>
                                            <Select isRtl={false} options={this.state.categories} value={this.state.category} onChange={async(e)=>{await this.setState({"category" : e}); this.filterSchemes()}}/>
                                        </div>

                                        
                                        <div className="form-group text-start my-2">
                                            <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">DBT</label>
                                            <Select isRtl={false} options={this.dbts} value={this.state.dbt} onChange={async(e)=>{await this.setState({"dbt" : e}); this.filterSchemes()}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-9">                                
                                <div class="input-group my-2">
                                    <input type="text" onChange={(event)=>{this.searchSchemes(event.target.value)}} class="form-control" placeholder="Search here..."/>
                                </div>

                                <h5 className="text-start my-5 px-2">We found {this.state.schemes.length} schemes based on your preferences</h5>
                                {this.state.schemes.map((scheme)=>{
                                    return(
                                        <Link to={`/scheme/${scheme.id}`} className="card my-5 shadow">
                                            <div class="causes_boxed_text" style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                <h4 style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                    <Link to={`/scheme/${scheme.id}`} style={{'textAlign' : 'left', 'color' : '#000000'}}>{scheme.title}</Link>
                                                </h4>
                                                <label className="my-3" style={{'color' : 'grey'}}>{scheme.state}</label>

                                                <div style={{'height' : '54px', color:'#000000', 'textOverflow' : 'ellipsis', 'overflow' : 'hidden'}}>{parse(scheme.description)}</div>
                                            </div>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(StateSchemes)